// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== NAVBAR STYLES ===== */
.global-navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: transparent;
    border-bottom: 1px solid transparent;
    z-index: 9999;
    display: flex;
    align-items: center;
    transition: all 0.4s ease;
    opacity: 0;
    visibility: hidden;
}

.global-navbar.scrolled,
.global-navbar.always-visible {
    background: rgba(0, 0, 0, 0.95);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
    height: 70px;
    opacity: 1;
    visibility: visible;
}

.navbar-container {
    width: 100%;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.navbar-brand {
    display: flex;
    align-items: center;
    text-decoration: none;
    gap: 12px;
}

.navbar-logo-img {
    height: 40px;
    width: auto;
    object-fit: contain;
}

.navbar-links {
    display: flex;
    gap: 2.5rem;
    align-items: center;
}

.nav-link {
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.95rem;
    font-weight: 500;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: relative;
    padding: 0.5rem 0;
    transition: color 0.3s ease;
}

.nav-link:hover, .nav-link.active {
    color: #ffffff;
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: #ffffff;
    transition: width 0.3s ease;
}

.nav-link:hover::after, .nav-link.active::after {
    width: 100%;
}

.mobile-menu-btn {
    display: none;
    background: transparent;
    border: none;
    cursor: pointer;
    flex-direction: column;
    gap: 6px;
    padding: 0.5rem;
}

.mobile-menu-btn span {
    display: block;
    width: 24px;
    height: 2px;
    background: #ffffff;
    transition: all 0.3s ease;
}

/* Mobile Sidebar Overlay */
.mobile-nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    z-index: 9998;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.mobile-nav-overlay.open {
    opacity: 1;
    pointer-events: auto;
}

.mobile-nav-drawer {
    position: fixed;
    top: 0;
    right: -300px;
    width: 300px;
    height: 100vh;
    background: #0f172a;
    z-index: 10000;
    padding: 6rem 2rem 2rem 2rem;
    transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: -5px 0 30px rgba(0, 0, 0, 0.5);
    border-left: 1px solid rgba(255, 255, 255, 0.05);
}

.mobile-nav-drawer.open {
    right: 0;
}

.close-menu-btn {
    position: absolute;
    top: 24px;
    right: 24px;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 1.5rem;
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
}

.mobile-nav-links {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.mobile-nav-link {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: 500;
    padding: 0.5rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    transition: color 0.3s ease;
}

.mobile-nav-link:hover, .mobile-nav-link.active {
    color: #ffffff;
    border-bottom-color: rgba(255, 255, 255, 0.2);
}

@media (max-width: 768px) {
    .navbar-links {
        display: none;
    }
    .mobile-menu-btn {
        display: flex;
    }
    .navbar-container {
        padding: 0 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,+BAA+B;IAC/B,kDAAkD;IAClD,yCAAyC;IACzC,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,mDAAmD;IACnD,0CAA0C;IAC1C,gDAAgD;AACpD;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;IAClD,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ===== NAVBAR STYLES ===== */\n.global-navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 80px;\n    background: transparent;\n    border-bottom: 1px solid transparent;\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    transition: all 0.4s ease;\n    opacity: 0;\n    visibility: hidden;\n}\n\n.global-navbar.scrolled,\n.global-navbar.always-visible {\n    background: rgba(0, 0, 0, 0.95);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);\n    height: 70px;\n    opacity: 1;\n    visibility: visible;\n}\n\n.navbar-container {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 2rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.navbar-brand {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    gap: 12px;\n}\n\n.navbar-logo-img {\n    height: 40px;\n    width: auto;\n    object-fit: contain;\n}\n\n.navbar-links {\n    display: flex;\n    gap: 2.5rem;\n    align-items: center;\n}\n\n.nav-link {\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 0.95rem;\n    font-weight: 500;\n    text-decoration: none;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    position: relative;\n    padding: 0.5rem 0;\n    transition: color 0.3s ease;\n}\n\n.nav-link:hover, .nav-link.active {\n    color: #ffffff;\n}\n\n.nav-link::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0;\n    height: 2px;\n    background: #ffffff;\n    transition: width 0.3s ease;\n}\n\n.nav-link:hover::after, .nav-link.active::after {\n    width: 100%;\n}\n\n.mobile-menu-btn {\n    display: none;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    flex-direction: column;\n    gap: 6px;\n    padding: 0.5rem;\n}\n\n.mobile-menu-btn span {\n    display: block;\n    width: 24px;\n    height: 2px;\n    background: #ffffff;\n    transition: all 0.3s ease;\n}\n\n/* Mobile Sidebar Overlay */\n.mobile-nav-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n    z-index: 9998;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s ease;\n}\n\n.mobile-nav-overlay.open {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.mobile-nav-drawer {\n    position: fixed;\n    top: 0;\n    right: -300px;\n    width: 300px;\n    height: 100vh;\n    background: #0f172a;\n    z-index: 10000;\n    padding: 6rem 2rem 2rem 2rem;\n    transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: -5px 0 30px rgba(0, 0, 0, 0.5);\n    border-left: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.mobile-nav-drawer.open {\n    right: 0;\n}\n\n.close-menu-btn {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 1.5rem;\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.mobile-nav-links {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.mobile-nav-link {\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    font-size: 1.2rem;\n    font-weight: 500;\n    padding: 0.5rem 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    transition: color 0.3s ease;\n}\n\n.mobile-nav-link:hover, .mobile-nav-link.active {\n    color: #ffffff;\n    border-bottom-color: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 768px) {\n    .navbar-links {\n        display: none;\n    }\n    .mobile-menu-btn {\n        display: flex;\n    }\n    .navbar-container {\n        padding: 0 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
